<template>
  <div class="container">
    <div v-if="permission">
      <div class="row-button">
        <Moda />
        <div class="btn-direction-flex">
          <b-button
            pill
            variant="primary"
            class="btn-one"
            @click="guardarBorrador"
            v-if="userPermissions"
          >
            Guardar como borrador
          </b-button>

          <b-button
            pill
            variant="primary"
            class="btn-two"
            v-if="userPermission"
            @click="guardarYFinalizar"
          >
            Guardar y finalizar
          </b-button>
        </div>
      </div>

      <b-row v-if="userPermissions" class="">
        <b-form-checkbox
          style="display:flex;   justify-content: flex-end; "
          v-model="checked"
          name="check-button"
          switch
        >
          <span class="span" v-if="checked">No Aplica</span>
          <span class="span" v-else>No Aplica</span>
        </b-form-checkbox>
      </b-row>

      <b-row v-if="checked">
        <AlertError />
      </b-row>

      <b-row v-else>
        <TableCompromiso :selectedData="selectedData" />
        <br />
        <br />

        <Tabla :lista="listData" @MainHandlerSelectedRow="handlerSelectedRow" />
      </b-row>
    </div>

    <div v-else>
      <AlertError v-if="checked" />
      <TableCompromiso v-if="!checked" :selectedData="selectedData" />
    </div>
  </div>
</template>

<script>
// import Loading from "../../../components/tools/Loading.vue";
import Tabla from "./Tabla.vue";
import Moda from "./Moda.vue";
import { showAlert } from "../../../components/tools/utils";
import axios from "axios";
import { mapState } from "vuex";
import TableCompromiso from "./TableCompromiso";
import Swal from "sweetalert2";
import AlertError from "../../../components/error/AlertError.vue";

export default {
  components: {
    // Loading,
    Tabla,
    Moda,
    TableCompromiso,
    AlertError,
  },
  data() {
    return {
      file: null,
      loading: false,
      showListaData: false,
      selectedData: [],
      anexoPut: null,
      permission: false,
      selectedDatas: [],
      userPermission: true,
      userPermissions: true,
      datosUser: null,
      checked: false,
    };
  },
  props: ["setPermission", "listData", "tablesData"],

  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },

  methods: {
    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 8) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4 ||
        relacionUs.rolId === 5
      ) {
        this.permission = true;
      }
    },

    handlerSelectedRow(data) {
      this.selectedData = data;
    },

    uploadFile: async function() {
      if (!this.file) return;
      let formData = new FormData();
      formData.append("file_uploaded", this.file);
      formData.append("servicio", this.$route.params.idServicio);
      formData.append("anexo", 5);
      console.log(formData.get("file"));
      // this.showListaData = false;
      // this.loading = true;
      // this.setPermission();
      // setTimeout(() => {
      //   this.loading = false;
      //   this.showListaData = true;
      // }, 3000);
      console.log("Antes del try-catch");
      try {
        console.log("Antes de la peticion");
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/`,
          formData,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        this.loading = false;
        this.showListaData = true;
        console.log("dESPUES DE LA PETICION");
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },

    onChangeFileUpload() {
      const nuevoArchivo = this.$refs.file.files[0];
      const validFiles = [
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (!validFiles.includes(nuevoArchivo.type)) {
        this.file = null;
        return;
      }
      console.log(nuevoArchivo);
      this.file = nuevoArchivo;
    },

    buildData: function(type) {
      return {
        anio: "2022",
        idServicio: this.$route.params.idServicio,
        data: {
          content: this.selectedData,
          aplica: this.checked,
        },
        elaboracion: type,
        nombre: "compromisos",
      };
    },

    buildDataFinalizado: function(type) {
      return {
        anio: "2022",
        idServicio: this.$route.params.idServicio,
        data: {
          content: this.selectedData,
          aplica: this.checked,
        },
        elaboracion: type,
        nombre: "compromisos",
      };
    },

    guardarBorrador: async function() {
      const toSend = this.buildData("borrador");
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
        this.obtener();
        console.log(res);
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            anio: "2022",
            idServicio: this.$route.params.idServicio,
            data: {
              content: this.selectedData,
              aplica: this.checked,
            },
            elaboracion: "borrador",
            nombre: "compromisos",
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );
          this.obtener();
          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
        console.log(error);
      }
    },

    obtener: async function() {
      try {
        const obj = {
          anio: "2022",
          nombre: "genero",
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=compromisos`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.checked = res.data.info.aplica;
        console.log("Hola mundo", this.checked);
        if (res.data.info.content) {
          this.selectedData = res.data.info.content;
        }
        console.log("content", this.selectedData);
      } catch (error) {
        console.log(error);
      }
    },

    guardarYFinalizar: async function() {
      const toSend = this.buildData("finalizado");

      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar los datos?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            showAlert({
              icon: "success",
              text: "Guardado y finalizado exitosamente.",
              timerProgressBar: true,
              timer: 3000,
            });
            console.log(res);
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                anio: "2022",
                idServicio: this.$route.params.idServicio,
                data: {
                  content: this.selectedData,
                  aplica: this.checked,
                },
                elaboracion: "finalizado",
                nombre: "compromisos",
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );

              showAlert({
                icon: "success",
                text: "Documento Guardado ",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
            console.log(error);
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },

    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const data = JSON.parse(localStorage.getItem("user"));
        const relacionUs = data.servicios.find(
          (s) => s.id === parseInt(this.$route.params.idServicio)
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);

        //funcionario Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 5)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermission = false;
        }

        //Jefe de Servicio BGI Borrador
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermissions = false;
        }

        //Jefe de Servicio BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermission = false;
        }

        //Funcionario
        if (relacionUs.rolId === 5) {
          this.userPermission = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.obtener();
    this.obtenerRelacionUsuarioServicio();
    this.obtenerRevision();
  },
};
</script>
<style scoped>
.row-button {
  display: flex;
  justify-content: space-between;
  margin: 25px 0;
}

.row-checkbox {
  display: flex;
}

.span {
  font-size: 18px;
  color: #052333;
  font-weight: 600;
  display: grid;
  top: -10px;
}

.Checkbox-form {
  display: flex;
  justify-content: flex-end;
}
/* .buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0 10px 0;
}
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.archivo {
  margin: 10px 0 !important;
}

.button-pill-up {
  margin-left: 10px;
  width: 150px;
  background: #4f52ff;
  border: none;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: white;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-pill-up:hover {
  background: #3d185f;
}
input[type="file"] {
  display: none;
}
i {
  margin-right: 4px;
}
.main-text {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #b8f4e9;
  height: 50px;
}
.main-text > h6 {
  font-weight: bold;
  color: #515151;
  margin: 0;
  text-align: center;
  margin: 15px;
} */
</style>
